const about = {
    name: 'Delaney Stewart',
    role: 'Artist & Printmaker',
    location: 'Leucadia, California',
    lead: 'Interdisciplinary artist and printmaker working with Japanese print traditions, rooted in print, paper, and ecological kinship.',
    bio: [
        'Delaney Stewart is a 25-year-old artist and printmaker based in Leucadia, California. Her practice is rooted in traditional and contemporary printmaking, inspired by Japanese culture, language and a deep connection to the natural world. She specializes in mokuhanga and relief printing, with additional experience in lithography, papermaking, photo-intaglio, cyanotype, and screenprinting.',
        'At the heart of Delaney’s practice is a love of printmaking as a democratic and community-based art form. Her practice is deeply rooted in collaboration and mentorship. She actively works within local printmaking communities in San Diego, learning from fellow artists and mentors while contributing to outreach programs, public markets, and community-based arts initiatives.',
        'Delaney currently lives and works in a small log cabin in her hometown of Leucadia, where she continues to develop her practice and deepen her relationship with the craft of printmaking.',
    ],
    education: [
        {
            place: 'Kyoto University of the Arts',
            detail: 'Special Studies in Printmaking, Mokuhanga',
            when: 'Summer 2023',
            where: 'Kyoto, Japan',
        },
        {
            place: 'Awagami Paper Factory',
            detail: 'Special Studies in Papermaking',
            when: 'Summer 2023',
            where: 'Tokushima, Japan',
        },
        {
            place: 'Green House Project Intern',
            detail: 'Cultivated a 1-acre community garden with\nan emphasis on art, sustainability, and agro-ecology.',
            when: 'Spring 2023',
            where: 'Santa Cruz, CA',
        },
        {
            place: 'University of California, Santa Cruz',
            detail: 'BFA, Fine Art and Language',
            when: '2019–2023',
            where: 'Santa Cruz, CA',
        },
    ],
    exhibitions: [
        {
            title: 'Día de las Madres Exhibition',
            kind: 'Exhibition',
            venue: 'Athenaeum Art Center',
            where: 'San Diego, CA',
            when: '2025',
        },
        {
            title: 'Heavenly Bamboo',
            kind: 'Solo Exhibition',
            venue: 'Elena Baskins Studio',
            where: 'Santa Cruz, CA',
            when: '2023',
        },
        {
            title: 'Relief',
            kind: 'Group Exhibition',
            venue: 'Geijutsu-kan',
            where: 'Kyoto, Japan',
            when: '2023',
        },
        {
            title: 'Eduardo Carrillo Memorial Scholar',
            kind: 'Award',
            venue: '',
            where: 'Santa Cruz, CA',
            when: '2023',
        },
        {
            title: 'Convocation Honors',
            kind: 'Group Exhibition',
            venue: 'Eduardo Carrillo Gallery',
            where: 'Santa Cruz, CA',
            when: '2022',
        },
    ],
};

export default about;
